import { render } from "./AchieveAddStock.vue?vue&type=template&id=2127587a&scoped=true"
import script from "./AchieveAddStock.vue?vue&type=script&lang=js"
export * from "./AchieveAddStock.vue?vue&type=script&lang=js"

import "./AchieveAddStock.vue?vue&type=style&index=0&id=2127587a&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2127587a"]])

export default __exports__